import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeLatest } from "redux-saga/effects";
import { notificationApi } from "../../services/notification.api";
import { AppNotification } from "../../types/notification.definition";
import {
  deleteNotificationFailure,
  deleteNotificationRequest,
  deleteNotificationSuccess,
  fetchNotificationsFailure,
  fetchNotificationsRequest,
  fetchNotificationsSuccess,
  markAllAsReadFailure,
  markAllAsReadRequest,
  markAllAsReadSuccess,
  markAsReadFailure,
  markAsReadRequest,
  markAsReadSuccess,
} from "../reducers/notificationSlice";

function* fetchNotificationsSaga(): Generator<unknown, void, AppNotification[]> {
  try {
    const notifications = yield call(notificationApi.getNotifications);
    yield put(fetchNotificationsSuccess(notifications));
  } catch (error) {
    yield put(
      fetchNotificationsFailure(
        error instanceof Error ? error.message : "Failed to fetch notifications"
      )
    );
  }
}

function* markAsReadSaga({
  payload: id,
}: PayloadAction<number>): Generator<unknown, void, AppNotification> {
  try {
    const updated = yield call(notificationApi.markAsRead, id);
    yield put(markAsReadSuccess(updated));
  } catch (error) {
    yield put(
      markAsReadFailure(
        error instanceof Error ? error.message : "Failed to mark as read"
      )
    );
  }
}

function* markAllAsReadSaga(): Generator<unknown, void, void> {
  try {
    yield call(notificationApi.markAllAsRead);
    yield put(markAllAsReadSuccess());
  } catch (error) {
    yield put(
      markAllAsReadFailure(
        error instanceof Error ? error.message : "Failed to mark all as read"
      )
    );
  }
}

function* deleteNotificationSaga({
  payload: id,
}: PayloadAction<number>): Generator<unknown, void, void> {
  try {
    yield call(notificationApi.deleteNotification, id);
    yield put(deleteNotificationSuccess(id));
  } catch (error) {
    yield put(
      deleteNotificationFailure(
        error instanceof Error ? error.message : "Failed to delete notification"
      )
    );
  }
}

export function* watchNotifications() {
  yield takeLatest(fetchNotificationsRequest.type, fetchNotificationsSaga);
  yield takeLatest(markAsReadRequest.type, markAsReadSaga);
  yield takeLatest(markAllAsReadRequest.type, markAllAsReadSaga);
  yield takeLatest(deleteNotificationRequest.type, deleteNotificationSaga);
}
